import createDataGridModel from '../../../util/createDataGridModel';
import { ManageRolesTabProp } from './types.ts';

export const createManageRolesTable = ({ getManageableRolesFx } : ManageRolesTabProp) => {
  const $$users = createDataGridModel({ type: 'client', effect: getManageableRolesFx });

  return {
    $$users
  };
};